import { Feature } from '../../models/feature';
import { Subscription } from '../../models/subscription';

/**
 * Metadata name under which a TestOps G3 subscription stores its Full-license count. Mirrors the
 * BE `TestOpsG3LicenseType.FULL_LICENSE` (see `TestOpsG3Subscription.toSubscriptionData()`),
 * which the v2 subscription view exposes as `metadata: [{ name, value }]`.
 */
export const TESTOPS_G3_FULL_LICENSE_METADATA = 'FULL_LICENSE';

/**
 * Seat/licence count to display for a subscription. `quota` is authoritative for every feature
 * except TestOps G3, whose `quota` is a placeholder (1): the self-serve quantity is the Full
 * licence count carried in metadata. Falls back to `quota` when that metadata is absent or not
 * numeric. Guest/Collab licences (Sales-managed) are intentionally not counted.
 */
export const getDisplayQuota = (subscription: Subscription): number => {
  const quota = subscription.quota ?? 0;
  if (subscription.feature !== Feature.TESTOPS_G3) {
    return quota;
  }
  const fullLicense = subscription.metadata?.find(
    metadata => metadata.name === TESTOPS_G3_FULL_LICENSE_METADATA,
  );
  if (fullLicense === undefined) {
    return quota;
  }
  // The wire value is a string (SubscriptionMetadataDTO.value) even though the model says number.
  const fullLicenseCount = Number(fullLicense.value);
  return Number.isFinite(fullLicenseCount) ? fullLicenseCount : quota;
};
